export default __webpack_public_path__ + "static/bg-projects-d64329838801ee93e86337e6de33db1d.png";